import * as React from "react";
import { CircleNotchIcon } from "@phosphor-icons/react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const spinnerVariants = cva("animate-spin", {
  variants: {
    size: {
      default: "h-4 w-4",
      sm: "h-3 w-3",
      lg: "h-6 w-6",
      xl: "h-8 w-8",
    },
    color: {
      default: "text-muted-foreground",
      primary: "text-primary",
      secondary: "text-secondary-foreground",
      destructive: "text-destructive",
      success: "text-green-600",
      warning: "text-yellow-600",
      info: "text-blue-600",
    },
  },
  defaultVariants: {
    size: "default",
    color: "default",
  },
});

export interface SpinnerProps
  extends
    Omit<
      React.ComponentPropsWithoutRef<typeof CircleNotchIcon>,
      "color" | "size"
    >,
    VariantProps<typeof spinnerVariants> {
  ref?: React.Ref<React.ElementRef<typeof CircleNotchIcon>>;
}

export const Spinner = ({
  ref,
  className,
  size,
  color,
  ...props
}: SpinnerProps) => (
  <CircleNotchIcon
    ref={ref}
    className={cn(spinnerVariants({ size, color, className }))}
    {...props}
  />
);

Spinner.displayName = "Spinner";
